/**
 * Global Helper: Select
 * ----------------------------------------------------------
 * Used to customize the look of select dropdowns
 * 
 * Package depndency: choices.js 
 * (https://www.npmjs.com/package/choices.js?ref=vanillalist)
 * ----------------------------------------------------------
 */
/* eslint-disable */
 import {registerLegacySalvoLiteComponent, legacySalvoLiteLog as log} from '@eastsideco/salvo-ts';
 import Choices from 'choices.js'
 
 /**
  * Component class 
  */
class Select {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._choices = null
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.buildChoices();
        this.initObserver();
    }

    buildChoices(select) {
        const _options = {
            searchEnabled: false,
            removeItems: false,
            paste: false,
            itemSelectText: '',
            shouldSort: false,
            ...JSON.parse(this._elem.getAttribute('[data-select]') || '{}')
        }

        let _selectElem = this._elem.querySelector('select');
        if (select) {
            _selectElem = select
        }

        if (!_selectElem) { return; }
        this._choices = new Choices(_selectElem, _options)
    }

    initObserver() {
        const observer = new MutationObserver(() => {
            const select = this._elem.querySelector('select');
            if (!select) { return; }
            this.buildChoices(select); 
        });
        observer.observe(this._elem, {
            subtree: true,
            childList: true
        });
    }
}
 
 /**
  * Export Call
  */
 export default registerLegacySalvoLiteComponent({
     component: Select,
     selector: '[data-select-wrapper]', // Required
 });